import { Check, TriangleAlert } from "lucide-react";
import type { EditorCompletion } from "@/lib/editor-completion";
import { getCompletionDescription } from "@/lib/editor-completion";
import { StatusHint } from "../ui/status-hint";
import styles from "./completion-status.module.css";

export function CompletionStatus({
  result,
  placement = "right",
  focusable = false,
  className = "",
}: {
  result: EditorCompletion;
  placement?: "right" | "bottom";
  focusable?: boolean;
  className?: string;
}) {
  const icon = result.state === "complete"
    ? <Check size={11} strokeWidth={3} />
    : result.state === "partial"
      ? <TriangleAlert size={12} strokeWidth={2.4} />
      : <i className={styles.emptyDot} />;

  return (
    <StatusHint
      className={className}
      focusable={focusable}
      icon={icon}
      label={getCompletionDescription(result)}
      placement={placement}
      tone={result.state === "complete" ? "success" : result.state === "partial" ? "warning" : "neutral"}
    />
  );
}
